define([
	"dojo/_base/declare",
	"csi/xml",
	"SiteAdmin/Locale",
	"SiteAdmin/Locale/Renderer"
], function(declare,xml,Locale,Renderer) {

	return declare(Renderer, {
		_getEnumValue: function(/*Context*/ctx) {
			// summary: return key for enum resource
			return xml.enumCreate(ctx.getParent().$Name, ctx.getNode().$Name);
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return display name of enum in customer default locale
			var	enumValue = this._getEnumValue(ctx);
			return Locale.getConfigResolver().getEnumName(enumValue) || Locale.getBaseConfigResolver().getEnumName(enumValue);
		}
	});
});